import React from 'react';
import CircularProgress from 'components_base/CircularProgress';

const CalculationMap = React.lazy(() => import('../components/CalculationMap'));

function CalculationMapView(props: any) {
  return (
    <React.Suspense fallback={<CircularProgress />}>
      <CalculationMap {...props} />
    </React.Suspense>
  );
}

export default CalculationMapView;
